import React, { useState, useEffect } from "react";
import apiClient from '../utils/apiClient';
import Select from "react-select";
import Swal from 'sweetalert2';
import { SERVER_BASE } from '../config/server';
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinusCircle, faTrash, faEdit, faCopy, faEllipsisV, faThumbsUp, faCancel, faTimesCircle, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useTable, usePagination, useSortBy, useGlobalFilter } from "react-table";
import {hasPermission} from "../utils/usePermissions";
import { useNavigate } from "react-router-dom";
// Global Search Filter Component
const GlobalFilter = ({ filter, setFilter }) => {
  const handleChange = (e) => {
    setFilter(e.target.value);

    // Reset pagination to first page
    localStorage.setItem("currentAllPageIndex", 0);
    localStorage.setItem("currentRejectedPageIndex", 0);
    localStorage.setItem("currentFinalPageIndex", 0);
    localStorage.setItem("currentDraftPageIndex", 0);
  };

  return (
    <input
      value={filter || ""}
      onChange={handleChange}
      placeholder="Search items..."
      style={{
        marginBottom: "10px",
        padding: "8px",
        fontSize: "16px",
        width: "100%",
        boxSizing: "border-box",
      }}
      className="form-control"
    />
  );
};
const ItemMasterList = ({permissions}) => {
  const [activeTab, setActiveTab] = useState('all');
  const [isEdit, setIsEdit] = useState(false);
  const [editItemId, setEditItemId] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [itemGroup, setItemGroup] = useState(null);
  const [type, setType] = useState(null);
  const [itemGroupCode, setItemGroupCode] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [itemName, setItemName] = useState("");
  const [printName, setPrintName] = useState("");
  const [itemDesc, setItemDesc] = useState("");
  const [size, setSize] = useState("");
  const [make, setMake] = useState("");
  const [color, setColor] = useState("");
  const [avgWeight, setAvgWeight] = useState("");
  const [uom, setUom] = useState(null);
  const [unit, setUnit] = useState("");
  const [concernedDepartments, setConcernedDepartments] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [additionalNames, setAdditionalNames] = useState([""]);
  const [grade, setGrade] = useState("");
  const [mmsCode, setMmsCode] = useState("");
  const [mmsName, setMmsName] = useState("");
  const [mmsDesc, setMmsDesc] = useState("");
  const [groupItemName, setGroupItemName] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [itemGroups, setItemGroups] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [items, setItems] = useState([]); // State for table data
  const [approvedItems, setApprovedItems] = useState([]); // State for table data
  const [rejectedItems, setRejectedItems] = useState([]);
  const code = localStorage.getItem("code");
  const email = localStorage.getItem("email");
  const token = localStorage.getItem("token");
  const name = localStorage.getItem('name');
  const role = localStorage.getItem('role');
  const badgeId = localStorage.getItem('badgeId');
  const [formVisible, setFormVisible] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [uoms, setUoms] = useState([]); // UOM data
  const [groupItems, setGroupItems] = useState([]);
  const [createdByOptions, setCreatedByOptions] = useState([]);
  const [loadingData, setLoadingData] = useState(true);


  const [typeFilter, setTypeFilter] = useState(() => {
    return localStorage.getItem("typeFilter") || "All";
  });
  const [groupFilterCode, setGroupFilterCode] = useState(() => {
    return localStorage.getItem("groupFilterCode") || "";
  });
  const [createdByFilter, setCreatedByFilter] = useState(() => {
    const saved = localStorage.getItem("createdByFilter");
    return saved ? JSON.parse(saved) : null;
  });



  const navigate = useNavigate();
  // Fetch Inventory Groups
  const fetchItemGroups = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/item-groups", {
        params: { code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setItemGroups(
        response.data.map((group) => ({
          value: group.groupName,
          label: `${group.groupCode} - ${group.groupName}`,
          type: group.type,
          itemGroupCode: group.groupCode,
        }))
      );
    } catch (error) {
      console.error("Error fetching item groups:", error);
    }
  };
  const fetchGroupItems = async () => {
    try {
      // Retrieve the token from localStorage
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('Unauthorized: No token found.');
        return;
      }
      // Make the request with the Authorization header
      const response = await apiClient.get(SERVER_BASE + '/getGroupItems', {
        headers: {
          Authorization: `Bearer ${token}`, // Include the JWT token in headers
        },
      });

      // Update the purposes state
      setGroupItems(response.data);
    } catch (error) {
      console.error('Error fetching groups:', error);
    }
  };
  const fetchUOMs = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/getUoms", {
        params: { code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setUoms(
        response.data.map((uom) => ({
          value: uom.abbreviation,
          label: `${uom.unit} - ${uom.abbreviation}`,
          unit: uom.unit
        }))
      );
    } catch (error) {
      console.error("Error fetching item groups:", error);
    }
  };

  // Fetch Departments
  const fetchDepartments = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/departments", {
        params: { code },

        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },

      });
      const departmentsData = response.data;
      setDepartments(
        departmentsData.map((dept) => ({
          value: dept.name,
          label: dept.name,
        }))
      );
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };
  const generateCreatedByOptions = (allItems) => {
    const uniqueCreatedByMap = new Map();

    allItems.forEach((item) => {
      const compositeKey = `${item.badgeId}|${item.createdByFirstName}`;
      if (!uniqueCreatedByMap.has(compositeKey)) {
        uniqueCreatedByMap.set(compositeKey, {
          value: item.badgeId,
          label: `${item.createdByFirstName} - ${item.badgeId}`,
          name: item.createdByFirstName,
        });
      }
    });

    return Array.from(uniqueCreatedByMap.values());
  };
  const fetchAllItems = async () => {
    try {
      const [allRes, approvedRes, rejectedRes] = await Promise.all([
        apiClient.get(SERVER_BASE + "/get-items", {
          params: { centerCode: code },
          headers: { Authorization: `Bearer ${token}` },
        }),
        apiClient.get(SERVER_BASE + "/get-items-approved", {
          params: { centerCode: code },
          headers: { Authorization: `Bearer ${token}` },
        }),
        apiClient.get(SERVER_BASE + "/get-items-rejected", {
          params: { centerCode: code },
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      const sortedItems = allRes.data.sort((a, b) => b.id - a.id);
      const sortedApproved = approvedRes.data.sort(
        (a, b) => new Date(b.approvedAt) - new Date(a.approvedAt)
      );
      const sortedRejected = rejectedRes.data.sort(
        (a, b) => new Date(b.approvedAt) - new Date(a.approvedAt)
      );

      setItems(sortedItems);
      setApprovedItems(sortedApproved);
      setRejectedItems(sortedRejected);

      const combinedItems = [...sortedItems, ...sortedApproved, ...sortedRejected];
      const createdByOptions = generateCreatedByOptions(combinedItems);
      setCreatedByOptions(createdByOptions);

    } catch (error) {
      setItems([]);
      setApprovedItems([]);
      setRejectedItems([]);
      console.error("Error fetching items:", error);
    }
  };

  // Fetch items for the table
  const fetchItems = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/get-items", {
        params: { centerCode: code },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const fetchApprovedItems = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/get-items-approved", {
        params: { centerCode: code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });

      const sortedItems = response.data.sort(
        (a, b) => new Date(b.approvedAt) - new Date(a.approvedAt) // sorts by full datetime
      );

      setApprovedItems(sortedItems);
    } catch (error) {
      setApprovedItems([]);
      console.error("Error fetching items:", error);
    }
  };


  const fetchRejectedItems = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/get-items-rejected", {
        params: { centerCode: code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      const sortedItems = response.data.sort(
        (a, b) => new Date(b.approvedAt) - new Date(a.approvedAt) // sorts by full datetime
      );
      setRejectedItems(sortedItems);

    } catch (error) {
      setRejectedItems([])
      console.error("Error fetching items:", error);
    }
  };

  const toggleFormVisibility = () => {
    setFormVisible(!formVisible);
    setShowForm(false)
    resetForm();
    resetGroupForm();
  };
  const toggleGroupFormVisibility = () => {
    setFormVisible(false);
    setShowForm(!showForm)
    resetForm();
    resetGroupForm();
  };
  const resetGroupForm = () => {
    setGroupItemName('');
    setSelectedItems([]);
  };
  const resetForm = () => {
    setItemGroup(null);
    setType(null);
    setItemGroupCode("");
    setItemName("");
    setItemDesc("");
    setSize("");
    setMake("");
    setColor("");
    setAvgWeight("");
    setUom(null);
    setUnit("");
    setGrade("");
    setConcernedDepartments([]);
    setRemarks("");
    setAdditionalNames([""]);
    setPrintName("");
  };

  // Function to update the Print Name dynamically
  useEffect(() => {
    const baseName = `${itemName} ${size} ${color}`.trim();
    const additionalDetails = [make, grade].filter(Boolean).join(" ");
    const newPrintName = additionalDetails
      ? `${baseName} - ${additionalDetails}`
      : baseName;
    setPrintName(newPrintName);
  }, [itemName, color, size, make, grade]); // Dependencies

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
  };
  const handleItemsChange = (selectedOptions) => {
    setSelectedItems(selectedOptions || []);
  };

  const handleSelectChange = (selectedOption, { name }) => {
    if (name === "itemGroup") {
      setItemGroup(selectedOption)
      setItemGroupCode(selectedOption?.itemGroupCode || "")
    }
    if (name === "uom") {
      setUom(selectedOption)
      setUnit(selectedOption?.unit || "")
    }
    if (name === "type") {
      setType(selectedOption)
    }
  };

  const handleConcernedDeptSelectChange = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "all")) {
      setConcernedDepartments(departments);
    } else {
      setConcernedDepartments(selectedOptions);
    }
  };
  const getOptions = () => {
    return [{ value: "all", label: "Select All" }, ...departments];
  };

  const handleAdditionalNameChange = (index, value) => {
    const newAdditionalNames = [...additionalNames];
    newAdditionalNames[index] = value;
    setAdditionalNames(newAdditionalNames);
  };

  const handleAddAdditionalName = () => {
    setAdditionalNames([...additionalNames, ""]);
  };

  const handleDeleteAdditionalName = (index) => {
    const newAdditionalNames = [...additionalNames];
    newAdditionalNames.splice(index, 1);
    setAdditionalNames(newAdditionalNames);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if all required fields are filled
    if (!itemName) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Enter Inventory Name!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast: true,
      });
      return;
    }
    if (!itemGroup) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select Inventory Group!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast: true,
      });
      return;
    }
    if (!type) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select Inventory type!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast: true,
      });
      return;
    }
    if (!concernedDepartments.length) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select at least One Department!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast: true,
      });
      return;
    }
    if (!uom) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select UOM!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast: true,
      });
      return;
    }

    let submissionData = {
      itemName,
      itemGroup: itemGroup?.value || null,
      itemGroupCode,
      type: type?.value || null,
      itemDesc,
      size,
      make,
      color,
      avgWeight,
      grade,
      printName,
      uom: uom?.value || null,
      unit,
      concernedDepartments: concernedDepartments?.map((d) => d.value) || [],
      additionalNames: additionalNames || [],
      code,
      email
    };

    try {
      // Attempt to save the item
      if (isEdit) {
        submissionData = { ...submissionData, itemCode: itemCode }

        // Update API call
        await apiClient.post(`${SERVER_BASE}/editItem/${editItemId}`, submissionData, {
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          }
        });
        Swal.fire({
          icon: 'success',
          title: 'Inventory updated successfully!',
          toast: true,
          position: 'top-end',
          timer: 2000,
          showConfirmButton: false,
        });
        setEditItemId(null);
        setIsEdit(false);
      } else {
        // Create API call
        const response = await apiClient.post(SERVER_BASE + "/save-item", submissionData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        Swal.fire({
          icon: 'success',
          title: 'Created!',
          toast: true,
          position: 'top-end',  // Positioning Swal to the right end
          showConfirmButton: false,
          timer: 1500, // Auto close after 1.5 seconds
        });
      }
      resetForm();
      fetchItems(); // Refresh the table after submission
      fetchApprovedItems();
    } catch (error) {
      console.error("Error saving data:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response.data.message,
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
      });
    }
  };

  const handleSubmitGroup = (e) => {
    e.preventDefault();

    if (groupItemName.trim() === '' || selectedItems.length === 0) {
      Swal.fire('Please fill both the required fields', '', 'warning');
      return;
    }

    // Retrieve token from localStorage
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('Unauthorized: No token found.');
      Swal.fire('Unauthorized', 'You need to log in to perform this action.', 'error');
      return;
    }

    const itemsNames = selectedItems.map((item) => item.value);

    Swal.fire({
      title: editIndex !== null ? 'Confirm Update' : 'Confirm Create',
      text: editIndex !== null ? 'Are you sure you want to update this group?' : 'Are you sure you want to create this group?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          if (editIndex !== null) {
            await apiClient.put(
              `${SERVER_BASE}/updateGroupItem/${editIndex}`,
              {
                name: groupItemName,
                itemNames: itemsNames,
                code,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`, // Add the JWT token in the header
                },
              }
            );
            // fetchPurposes();
            setEditIndex(null);
          } else {
            // Create new purpose
            await apiClient.post(
              `${SERVER_BASE}/addGroupItem`,
              {
                name: groupItemName,
                itemNames: itemsNames,
                code,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`, // Add the JWT token in the header
                },
              }
            );
            // fetchPurposes();
          }

          resetGroupForm();
          Swal.fire(
            editIndex !== null ? 'Updated!' : 'Created!',
            `Group has been ${editIndex !== null ? 'updated' : 'created'}.`,
            'success'
          );
          fetchGroupItems();
        } catch (error) {
          console.error('Error saving group:', error);
          Swal.fire('Error', error.response.data.message, 'error');
        }
      }
    });
  };

  const handleEdit = (item) => {
    navigate('../itemMaster', { state: { item: item } });
  };
  const handleAddDepartment = (item) => {
    navigate('../itemMaster', { state: { item: item, onlyDept: true } });
  };

  const handleEditGroup = (row) => {
    setGroupItemName(row?.groupItemName);
    const associatedItems = row?.itemGroups.map((item) => {
      return { value: item.printItemName, label: item.printItemName };
    });
    setSelectedItems(associatedItems);
    setEditIndex(row.groupId);
    setShowForm(true);
    setFormVisible(false);
    resetForm();
  };
  const handleClone = (item) => {
    navigate('../itemMaster', { state: { cloneItem: item } });
  };

  const resetAllFilters = () => {
    localStorage.setItem("currentDraftPageIndex", 0);
    localStorage.setItem("currentDraftPageSize", 25);
    localStorage.setItem("currentFinalPageIndex", 0);
    localStorage.setItem("currentFinalPageSize", 25);
    localStorage.setItem("currentRejectedPageIndex", 0);
    localStorage.setItem("currentRejectedPageSize", 25);
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await Promise.all([fetchItemGroups(), fetchDepartments(), fetchAllItems(), fetchUOMs(), fetchGroupItems()]);
      } catch (err) {
        console.error("Initial data fetch failed", err);
      } finally {
        setLoadingData(false); // ✅ Hide spinner when both are done
      }
    };
    fetchInitialData();
  }, []);


  // React Table configuration
  const columns = React.useMemo(
    () => [
      { Header: "Print Name", accessor: "printName" },
      { Header: "Inventory", accessor: "itemName" },
      { Header: "Size", accessor: "size" },
      { Header: "Color", accessor: "color" },
      { Header: "Made of (Material)", accessor: "make" },
      { Header: "Grade", accessor: "grade" },
      { Header: "Brand Name", accessor: "brandName" },
      { Header: "UOM", accessor: "uom" },
      { Header: "Weight", accessor: "avgWeight" },
      { Header: "Alias", accessor: "additionalNames" },
      { Header: "Depts", accessor: "concernedDepartments" },
      { Header: "Description", accessor: "itemDesc" },
      { Header: "Type", accessor: "type", },
      {
        Header: "Group",
        accessor: "itemGroupCode", // still needed for sorting/filtering
        Cell: ({ row }) => {
          const { itemGroupCode, itemGroup } = row.original;
          return `${itemGroupCode} - ${itemGroup}`;
        }
      },
      {
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="d-flex gap-2 align-items-center">
              {/* Direct Edit Button */}

              {/* Kebab Dropdown for Other Actions */}
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-secondary "
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                <ul className="dropdown-menu">
                  {(permissions?.edit || role =='itManager') && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleEdit(row.original)}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" />
                      Edit
                    </button>
                  </li>
                  )}
                  {(permissions?.write || role =='itManager') && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleClone(row.original)}
                    >
                      <FontAwesomeIcon icon={faCopy} className="me-2" />
                      Clone
                    </button>
                  </li>
                  )}
                  <li>
                    <button
                      className="dropdown-item"
                    >
                      <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                      {row.original.createdByFirstName}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          );
        },
      }

    ],
    [permissions]
  );
  const columnsApproved = React.useMemo(
    () => [
      { Header: "Print Name", accessor: "printName" },
      { Header: "Inventory", accessor: "itemName" },
      { Header: "Size", accessor: "size" },
      { Header: "Color", accessor: "color" },
      { Header: "Made of (Material)", accessor: "make" },
      { Header: "Grade", accessor: "grade" },
      { Header: "Brand Name", accessor: "brandName" },
      { Header: "UOM", accessor: "uom" },
      { Header: "Weight", accessor: "avgWeight" },
      { Header: "Alias", accessor: "additionalNames" },
      { Header: "Depts", accessor: "concernedDepartments" },
      { Header: "Description", accessor: "itemDesc" },
      { Header: "Type", accessor: "type", },
      {
        Header: "Group",
        accessor: "itemGroupCode", // still needed for sorting/filtering
        Cell: ({ row }) => {
          const { itemGroupCode, itemGroup } = row.original;
          return `${itemGroupCode} - ${itemGroup}`;
        }
      },
      // {
      //   Header: "Created By",
      //   accessor: "createdByFirstName",
      //   Cell: ({ row }) => {
      //     const { createdByFirstName, createdAt } = row.original; // Access original row data
      //     const formattedDate = new Date(createdAt).toLocaleDateString("en-GB", {
      //       day: "2-digit",
      //       month: "2-digit",
      //     }); // Format date as DD-MM
      //     return `${createdByFirstName} On (${formattedDate})`;
      //   },
      // },      
      {
        Header: "Actions",
        Cell: ({ row }) => {
          const item = row.original;
          const [suggestionData, setSuggestionData] = useState({
            inventoryName: "",
            size: "",
            color: "",
            madeOf: "",
            grade: "",
            brandName: "",
            avgWeight: "",
            uom: "",
            remarks: "",
          });
          const [isSubmitting, setIsSubmitting] = useState(false);
          const [errors, setErrors] = useState({});

          const handleInputChange = (e) => {
            const { name, value } = e.target;
            setSuggestionData(prev => ({ ...prev, [name]: value }));
            if (errors.form) {
              setErrors(prev => ({ ...prev, form: "" }));
            }
          };

          const validateForm = () => {
            // Check if at least one field has value (excluding empty strings)
            const hasValue = Object.values(suggestionData).some(
              val => val && val.toString().trim() !== ""
            );

            if (!hasValue) {
              setErrors({ form: "Please fill at least one field" });
              return false;
            }
            setErrors({});
            return true;
          };

          const handleSuggestionSubmit = async () => {
            if (!validateForm()) return;

            setIsSubmitting(true);

            const payload = {
              itemId: item.id,
              ...suggestionData,
              createdAt: new Date().toISOString(),
              createdBy: name,
              createdByBadge: badgeId,
              status: "Suggested",
            };

            try {
              await apiClient.post(`${SERVER_BASE}/saveInventorySuggestion`, payload);
              Swal.fire({
                title: "Success!",
                text: "Suggestion submitted",
                icon: "success",
                timer: 1500,
                showConfirmButton: false
              });
              document.getElementById(`closeModal-${item.id}`)?.click();
            } catch (err) {
              Swal.fire({
                title: "Error!",
                text: err.response?.data?.message || "Submission failed",
                icon: "error",
              });
            } finally {
              setIsSubmitting(false);
            }
          };

          return (
            <div className="d-flex gap-2 align-items-center">
              {/* Actions Dropdown */}
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                <ul className="dropdown-menu">
                  {(permissions?.write || role =='itManager') && (
                  <li>
                    <button
                      className="dropdown-item py-1"
                      onClick={() => handleClone(item)}
                    >
                      <FontAwesomeIcon icon={faCopy} className="me-2 fs-6" />
                      Clone
                    </button>
                  </li>
                  )}
                  <li>
                    <button className="dropdown-item py-1">
                      <FontAwesomeIcon icon={faPlusCircle} className="me-2 fs-6" />
                      {item.createdByFirstName}
                    </button>
                  </li>
                  {(permissions?.edit || permissions?.write || role =='itManager') && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleAddDepartment(row.original)}
                    >
                      <FontAwesomeIcon icon={faPlus} className="me-2" />
                      Add Department
                    </button>
                  </li>
                  )}
                  <li>
                    <button
                      className="dropdown-item py-1"
                      data-bs-toggle="modal"
                      data-bs-target={`#suggestModal-${item.id}`}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2 fs-6" />
                      Edit Suggestion
                    </button>
                  </li>
                </ul>
              </div>

              {/* Suggestion Modal */}
              <div
                className="modal fade"
                id={`suggestModal-${item.id}`}
                tabIndex="-1"
                aria-labelledby="suggestModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <div className="modal-header p-2 bg-light">
                      <h5 className="modal-title fs-6 m-0">Edit Suggestion</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        id={`closeModal-${item.id}`}
                      ></button>
                    </div>
                    <div className="modal-body p-3">
                      {errors.form && (
                        <div className="alert alert-warning py-1 mb-2 small">
                          {errors.form}
                        </div>
                      )}

                      <div className="row g-1 row-cols-2 row-cols-md-3">
                        {[
                          { label: "Name", name: "inventoryName", cols: 2 },
                          { label: "Size", name: "size", cols: 1 },
                          { label: "Color", name: "color", cols: 1 },
                          { label: "Material", name: "madeOf", cols: 1 },
                          { label: "Grade", name: "grade", cols: 1 },
                          { label: "Brand", name: "brandName", cols: 2 },
                          { label: "Weight", name: "avgWeight", cols: 1 },
                          { label: "UOM", name: "uom", cols: 1 },
                        ].map((field) => (
                          <div className={`col mb-1`} key={field.name}>
                            <label className="form-label mb-0">
                              {field.label}
                            </label>
                            <input
                              type="text"
                              className="form-control form-control"
                              name={field.name}
                              value={suggestionData[field.name]}
                              onChange={handleInputChange}
                            />
                          </div>
                        ))}
                      </div>

                      <div className="mt-2">
                        <label className="form-label mb-0">Remarks</label>
                        <textarea
                          className="form-control form-control"
                          name="remarks"
                          rows={2}
                          value={suggestionData.remarks}
                          onChange={handleInputChange}
                        ></textarea>
                      </div>
                    </div>
                    <div className="modal-footer p-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        data-bs-dismiss="modal"
                        disabled={isSubmitting}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={handleSuggestionSubmit}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-1"></span>
                            Saving
                          </>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        },
      }

    ],
    [permissions]
  );
  const columnsRejected = React.useMemo(
    () => [
      { Header: "Print Name", accessor: "printName" },
      { Header: "Inventory", accessor: "itemName" },
      { Header: "Size", accessor: "size" },
      { Header: "Color", accessor: "color" },
      { Header: "Made of (Material)", accessor: "make" },
      { Header: "Grade", accessor: "grade" },
      { Header: "Brand Name", accessor: "brandName" },
      { Header: "UOM", accessor: "uom" },
      { Header: "Weight", accessor: "avgWeight" },
      { Header: "Alias", accessor: "additionalNames" },
      { Header: "Depts", accessor: "concernedDepartments" },
      { Header: "Description", accessor: "itemDesc" },
      { Header: "Type", accessor: "type", },
      {
        Header: "Group",
        accessor: "itemGroupCode", // still needed for sorting/filtering
        Cell: ({ row }) => {
          const { itemGroupCode, itemGroup } = row.original;
          return `${itemGroupCode} - ${itemGroup}`;
        }
      },
      { Header: "Reason", accessor: "rejectedReason" },
      // {
      //   Header: "Created By",
      //   accessor: "createdByFirstName",
      //   Cell: ({ row }) => {
      //     const { createdByFirstName, createdAt } = row.original; // Access original row data
      //     const formattedDate = new Date(createdAt).toLocaleDateString("en-GB", {
      //       day: "2-digit",
      //       month: "2-digit",
      //     }); // Format date as DD-MM
      //     return `${createdByFirstName} On (${formattedDate})`;
      //   },
      // },      
      {
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="d-flex gap-2 align-items-center">
              {/* Kebab Dropdown for Other Actions */}
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-secondary "
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                <ul className="dropdown-menu">
                  {(permissions?.edit || role =='itManager') && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleEdit(row.original)}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" />
                      Edit
                    </button>
                  </li>
                  )}
                  <li>
                    <button
                      className="dropdown-item"
                    >
                      <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                      {row.original.createdByFirstName}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          );
        },
      }
    ],
    [permissions]
  );
  const allItems = React.useMemo(
    () => [...items, ...approvedItems, ...rejectedItems],
    [items, approvedItems, rejectedItems]
  );
  const columnsAll = React.useMemo(
    () => [
      { Header: "Print Name", accessor: "printName" },
      // { Header: "Inventory", accessor: "itemName" },
      // { Header: "Size", accessor: "size" },
      // { Header: "Color", accessor: "color" },
      // { Header: "Made of (Material)", accessor: "make" },
      // { Header: "Grade", accessor: "grade" },
      // { Header: "Brand Name", accessor: "brandName" },
      { Header: "UOM", accessor: "uom" },
      { Header: "Weight", accessor: "avgWeight" },
      { Header: "Alias", accessor: "additionalNames" },
      { Header: "Depts", accessor: "concernedDepartments" },
      { Header: "Description", accessor: "itemDesc" },
      { Header: "Type", accessor: "type" },
      {
        Header: "Group",
        accessor: "itemGroupCode",
        Cell: ({ row }) => {
          const { itemGroupCode, itemGroup } = row.original;
          return `${itemGroupCode} - ${itemGroup}`;
        }
      },
      { Header: "Reason", accessor: "rejectedReason" }, // Will be empty for non-rejected items
      {
        Header: "Created By",
        accessor: "createdByFirstName",
        Cell: ({ row }) => {
          const { createdByFirstName, createdAt } = row.original;
          const formattedDate = new Date(createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
          });
          return `${createdByFirstName} On (${formattedDate})`;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) => {
          if (items.some(item => item.id === row.original.id)) return "Draft";
          if (approvedItems.some(item => item.id === row.original.id)) return "Final";
          if (rejectedItems.some(item => item.id === row.original.id)) return "On Hold";
          return "Unknown";
        }
      },
      {
        Header: "Actions",
        Cell: ({ row }) => {
          const item = row.original;
          const isDraft = items.some(i => i.id === item.id);
          const isApproved = approvedItems.some(i => i.id === item.id);
          const isRejected = rejectedItems.some(i => i.id === item.id);
          const [suggestionData, setSuggestionData] = useState({
            inventoryName: "",
            size: "",
            color: "",
            madeOf: "",
            grade: "",
            brandName: "",
            avgWeight: "",
            uom: "",
            remarks: "",
          });
          const [isSubmitting, setIsSubmitting] = useState(false);
          const [errors, setErrors] = useState({});

          const handleInputChange = (e) => {
            const { name, value } = e.target;
            setSuggestionData(prev => ({ ...prev, [name]: value }));
            if (errors.form) {
              setErrors(prev => ({ ...prev, form: "" }));
            }
          };

          const validateForm = () => {
            // Check if at least one field has value (excluding empty strings)
            const hasValue = Object.values(suggestionData).some(
              val => val && val.toString().trim() !== ""
            );

            if (!hasValue) {
              setErrors({ form: "Please fill at least one field" });
              return false;
            }
            setErrors({});
            return true;
          };

          const handleSuggestionSubmit = async () => {
            if (!validateForm()) return;

            setIsSubmitting(true);

            const payload = {
              itemId: item.id,
              ...suggestionData,
              createdAt: new Date().toISOString(),
              createdBy: name,
              createdByBadge: badgeId,
              status: "Suggested",
            };

            try {
              await apiClient.post(`${SERVER_BASE}/saveInventorySuggestion`, payload);
              Swal.fire({
                title: "Success!",
                text: "Suggestion submitted",
                icon: "success",
                timer: 1500,
                showConfirmButton: false
              });
              document.getElementById(`closeModal-${item.id}`)?.click();
            } catch (err) {
              Swal.fire({
                title: "Error!",
                text: err.response?.data?.message || "Submission failed",
                icon: "error",
              });
            } finally {
              setIsSubmitting(false);
            }
          };

          return (
            <div className="d-flex gap-2 align-items-center">
              {isDraft && (
                <div className="dropdown">
                  <button className="btn btn-sm btn-outline-secondary" type="button" data-bs-toggle="dropdown">
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </button>
                  <ul className="dropdown-menu">
                    {(permissions?.edit || role =='itManager') && (
                    <li>
                      <button className="dropdown-item" onClick={() => handleEdit(item)}>
                        <FontAwesomeIcon icon={faEdit} className="me-2" />
                        Edit
                      </button>
                    </li>
                    )}
                    {(permissions?.write || role =='itManager') && (
                    <li>
                      <button className="dropdown-item" onClick={() => handleClone(item)}>
                        <FontAwesomeIcon icon={faCopy} className="me-2" />
                        Clone
                      </button>
                    </li>
                    )}
                  </ul>
                </div>
              )}

              {isApproved && (<>
                <div className="dropdown">
                  <button className="btn btn-sm btn-outline-secondary" type="button" data-bs-toggle="dropdown">
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </button>
                  <ul className="dropdown-menu">
                    {(permissions?.write || role =='itManager') && (
                    <li>
                      <button className="dropdown-item py-1" onClick={() => handleClone(item)}>
                        <FontAwesomeIcon icon={faCopy} className="me-2 fs-6" />
                        Clone
                      </button>
                    </li>
                    )}
                    <li>
                      <button className="dropdown-item py-1" data-bs-toggle="modal" data-bs-target={`#suggestModal-${item.id}`}>
                        <FontAwesomeIcon icon={faEdit} className="me-2 fs-6" />
                        Edit Suggestion
                      </button>
                    </li>
                  </ul>
                </div>
                <div
                  className="modal fade"
                  id={`suggestModal-${item.id}`}
                  tabIndex="-1"
                  aria-labelledby="suggestModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                      <div className="modal-header p-2 bg-light">
                        <h5 className="modal-title fs-6 m-0">Edit Suggestion</h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          id={`closeModal-${item.id}`}
                        ></button>
                      </div>
                      <div className="modal-body p-3">
                        {errors.form && (
                          <div className="alert alert-warning py-1 mb-2 small">
                            {errors.form}
                          </div>
                        )}

                        <div className="row g-1 row-cols-2 row-cols-md-3">
                          {[
                            { label: "Name", name: "inventoryName", cols: 2 },
                            { label: "Size", name: "size", cols: 1 },
                            { label: "Color", name: "color", cols: 1 },
                            { label: "Material", name: "madeOf", cols: 1 },
                            { label: "Grade", name: "grade", cols: 1 },
                            { label: "Brand", name: "brandName", cols: 2 },
                            { label: "Weight", name: "avgWeight", cols: 1 },
                            { label: "UOM", name: "uom", cols: 1 },
                          ].map((field) => (
                            <div className={`col mb-1`} key={field.name}>
                              <label className="form-label mb-0">
                                {field.label}
                              </label>
                              <input
                                type="text"
                                className="form-control form-control"
                                name={field.name}
                                value={suggestionData[field.name]}
                                onChange={handleInputChange}
                              />
                            </div>
                          ))}
                        </div>

                        <div className="mt-2">
                          <label className="form-label mb-0">Remarks</label>
                          <textarea
                            className="form-control form-control"
                            name="remarks"
                            rows={2}
                            value={suggestionData.remarks}
                            onChange={handleInputChange}
                          ></textarea>
                        </div>
                      </div>
                      <div className="modal-footer p-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          data-bs-dismiss="modal"
                          disabled={isSubmitting}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={handleSuggestionSubmit}
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-1"></span>
                              Saving
                            </>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
              )}

              {isRejected && (
                <div className="dropdown">
                  <button className="btn btn-sm btn-outline-secondary" type="button" data-bs-toggle="dropdown">
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </button>
                  <ul className="dropdown-menu">
                    {(permissions?.edit || role =='itManager' ) && (
                    <li>
                      <button className="dropdown-item" onClick={() => handleEdit(item)}>
                        <FontAwesomeIcon icon={faEdit} className="me-2" />
                        Edit
                      </button>
                    </li>
                    )}
                  </ul>
                </div>
              )}
            </div>
          );
        }
      }
    ],
    [items, approvedItems, rejectedItems,permissions]
  );
  const tableInstanceAll = useTable(
    {
      columns: columnsAll,
      data: allItems,
      initialState: {
        pageIndex: parseInt(localStorage.getItem('currentAllPageIndex')) || 0,
        pageSize: parseInt(localStorage.getItem('currentAllPageSize')) || 25
      }
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const filteredItems = React.useMemo(() => {

    return items.filter(item => {

      const matchesType = typeFilter === "All" || item.type === typeFilter;
      const matchesGroup = !groupFilterCode || item.itemGroupCode === groupFilterCode;
      const matchesCreator =
        !createdByFilter ||
        (item.createdByFirstName === createdByFilter.name && item.badgeId === createdByFilter.badge);
      return matchesType && matchesGroup && matchesCreator;
    });
  }, [items, typeFilter, groupFilterCode, createdByFilter]);

  const filteredApprovedItems = React.useMemo(() => {
    return approvedItems.filter(item => {
      const matchesType = typeFilter === "All" || item.type === typeFilter;
      const matchesGroup = !groupFilterCode || item.itemGroupCode === groupFilterCode;
      const matchesCreator =
        !createdByFilter ||
        (item.createdByFirstName === createdByFilter.name && item.badgeId === createdByFilter.badge);
      return matchesType && matchesGroup && matchesCreator;
    });
  }, [approvedItems, typeFilter, groupFilterCode, createdByFilter]);

  const filteredRejectedItems = React.useMemo(() => {
    return rejectedItems.filter(item => {
      const matchesType = typeFilter === "All" || item.type === typeFilter;
      const matchesGroup = !groupFilterCode || item.itemGroupCode === groupFilterCode;
      const matchesCreator =
        !createdByFilter ||
        (item.createdByFirstName === createdByFilter.name && item.badgeId === createdByFilter.badge);
      return matchesType && matchesGroup && matchesCreator;
    });
  }, [rejectedItems, typeFilter, groupFilterCode, createdByFilter]);
  const filteredAllItems = React.useMemo(() => {

    return allItems.filter(item => {
      const matchesType = typeFilter === "All" || item.type === typeFilter;
      const matchesGroup = !groupFilterCode || item.itemGroupCode === groupFilterCode;
      const matchesCreator =
        !createdByFilter ||
        (item.createdByFirstName === createdByFilter.name && item.badgeId === createdByFilter.badge);
      return matchesType && matchesGroup && matchesCreator;
    });
  }, [allItems, typeFilter, groupFilterCode, createdByFilter]);


  const storedDraftPageIndex = parseInt(localStorage.getItem('currentDraftPageIndex')) || 0;
  const storedDraftPageSize = parseInt(localStorage.getItem('currentDraftPageSize')) || 25;

  const storedFinalPageIndex = parseInt(localStorage.getItem('currentFinalPageIndex')) || 0;
  const storedFinalPageSize = parseInt(localStorage.getItem('currentFinalPageSize')) || 25;

  const storedRejectedPageIndex = parseInt(localStorage.getItem('currentRejectedPageIndex')) || 0;
  const storedRejectedPageSize = parseInt(localStorage.getItem('currentRejectedPageSize')) || 25;


  const tableInstance1 = useTable(
    { columns, data: filteredItems, initialState: { pageIndex: storedDraftPageIndex, pageSize: storedDraftPageSize } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const tableInstance2 = useTable(
    { columns: columnsApproved, data: filteredApprovedItems, initialState: { pageIndex: storedFinalPageIndex, pageSize: storedFinalPageSize } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const tableInstance3 = useTable(
    { columns: columnsRejected, data: filteredRejectedItems, initialState: { pageIndex: storedRejectedPageIndex, pageSize: storedRejectedPageSize } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  useEffect(() => {
    if (tableInstance1?.state) {
      const { pageIndex, pageSize } = tableInstance1.state;
      localStorage.setItem("currentDraftPageIndex", pageIndex);
      localStorage.setItem("currentDraftPageSize", pageSize);
    }
  }, [tableInstance1?.state?.pageIndex, tableInstance1?.state?.pageSize]);

  useEffect(() => {
    if (tableInstance2?.state) {
      const { pageIndex, pageSize } = tableInstance2.state;
      localStorage.setItem("currentFinalPageIndex", pageIndex);
      localStorage.setItem("currentFinalPageSize", pageSize);
    }
  }, [tableInstance2?.state?.pageIndex, tableInstance2?.state?.pageSize]);

  useEffect(() => {
    if (tableInstance3?.state) {
      const { pageIndex, pageSize } = tableInstance3.state;
      localStorage.setItem("currentRejectedPageIndex", pageIndex);
      localStorage.setItem("currentRejectedPageSize", pageSize);
    }
  }, [tableInstance3?.state?.pageIndex, tableInstance3?.state?.pageSize]);
  useEffect(() => {
    if (tableInstanceAll?.state) {
      const { pageIndex, pageSize } = tableInstanceAll.state;
      localStorage.setItem("currentAllPageIndex", pageIndex);
      localStorage.setItem("currentAllPageSize", pageSize);
    }
  }, [tableInstanceAll?.state?.pageIndex, tableInstanceAll?.state?.pageSize]);

  // Helper for Rendering Tables
  const renderTable = ({
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state: { pageIndex = 0, pageSize = 25, globalFilter },
    setGlobalFilter,
    pageOptions = [],
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    setPageSize,
    state,
    typeFilter,
    setTypeFilter
  }) => {

    // Get the filtered rows count
    const filteredRowsCount = page.length;

    return (
      <div>
        <div className="row align-items-center mb-2">
          {/* Global Filter */}
          <div className="col-md-8">
            <GlobalFilter filter={state.globalFilter} setFilter={setGlobalFilter} />
          </div>
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              value={`Items: ${activeTab === 'all'
                ? items.length + approvedItems.length + rejectedItems.length
                : activeTab === 'draft'
                  ? items.length
                  : activeTab === 'finalized'
                    ? approvedItems.length
                    : rejectedItems.length
                }`}
              style={{
                marginBottom: '10px',
                padding: '8px',
                fontSize: '16px',
                width: '100%',
                boxSizing: 'border-box',
              }}
              disabled
            />
          </div>
          <div className="col-md-4">
            <Select
              options={createdByOptions} // [{ value: "BADGE001", label: "John - BADGE001", name: "John" }]
              value={createdByOptions.find(
                opt =>
                  opt.value === createdByFilter?.badge &&
                  opt.name === createdByFilter?.name
              ) || null}
              onChange={(selectedOption) => {
                const selected = selectedOption
                  ? { name: selectedOption.name, badge: selectedOption.value }
                  : null;
                setCreatedByFilter(selected);
                localStorage.setItem("createdByFilter", JSON.stringify(selected));
                resetAllFilters()
              }}
              placeholder="Filter by Created By"
              isClearable
            />
          </div>
          <div className="col-md-4">
            <Select
              options={itemGroups}
              value={itemGroups.find(opt => opt.itemGroupCode === groupFilterCode) || null}
              onChange={(selectedOption) => {
                const selectedCode = selectedOption?.itemGroupCode || "";
                setGroupFilterCode(selectedCode);
                localStorage.setItem("groupFilterCode", selectedCode);
                resetAllFilters()
              }}
              placeholder="Select Item Group"
              isClearable
            />
          </div>
          {/* Type Filter Dropdown */}
          <div className="col-md-4">
            <select
              className="form-select"
              value={typeFilter}
              onChange={(e) => {
                const value = e.target.value;
                setTypeFilter(value);
                localStorage.setItem("typeFilter", value);
                resetAllFilters()
              }}
              style={{
                marginBottom: '10px',
                padding: '8px',
                fontSize: '16px',
                width: '100%',
                boxSizing: 'border-box',
              }}
            >
              <option value="All">All</option>
              <option value="Asset">AC - Asset</option>
              <option value="Consumables">CU - Consumables</option>
              <option value="Fixtures & Fittings">FF - Fixtures & Fittings</option>
            </select>
          </div>
        </div>
        <div className="table-responsive">
          <table {...getTableProps()} className="table table-striped" style={{ fontSize: "13px", verticalAlign: "baseline" }}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div>
            <button
              className="btn btn-secondary me-2"
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              Previous
            </button>
            <button
              className="btn btn-secondary"
              onClick={nextPage}
              disabled={!canNextPage}
            >
              Next
            </button>
          </div>
          <span>
            Page {pageIndex + 1} of {pageOptions.length}
          </span>
          <select
            className="form-select w-auto"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[25, 50, 75, 100].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };

  if (loadingData) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '60vh' }}>
        <div className="spinner-border text-success" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-3 fs-5">Loading Item List...</div>
      </div>
    );
  }
  return (
    <div className="formcontainer mt-5">
      {(permissions?.read || permissions?.write || role =='itManager')&& (<>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h3>Inventory Master</h3>
        <div className="ledger-count">
          Total Items: <strong>{items.length + approvedItems.length + rejectedItems.length}</strong>
        </div>
      </div>
      </>)}
      {(permissions?.write || role =='itManager') && (
      <button
        className="btn btn-outline-success mb-2"
        onClick={() => { navigate('../itemMaster') }}
      >
        Add Inventory
      </button>
      )}
        {(permissions?.read || role =='itManager')&& (<>
      <div className="container mt-2">
        <ul className="nav nav-tabs" id="itemTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'all' ? 'active' : ''}`}
              id="all-tab"
              data-bs-toggle="tab"
              data-bs-target="#all"
              type="button"
              role="tab"
              aria-controls="all"
              aria-selected={activeTab === 'all'}
              onClick={() => setActiveTab('all')}
            >
              All Items
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'finalized' ? 'active' : ''}`}
              id="finalized-tab"
              data-bs-toggle="tab"
              data-bs-target="#finalized"
              type="button"
              role="tab"
              aria-controls="finalized"
              aria-selected={activeTab === 'finalized'}
              onClick={() => setActiveTab('finalized')}
            >
              Finalized Items
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'draft' ? 'active' : ''}`}
              id="draft-tab"
              data-bs-toggle="tab"
              data-bs-target="#draft"
              type="button"
              role="tab"
              aria-controls="draft"
              aria-selected={activeTab === 'draft'}
              onClick={() => setActiveTab('draft')}
            >
              Draft Items
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'rejected' ? 'active' : ''}`}
              id="rejected-tab"
              data-bs-toggle="tab"
              data-bs-target="#rejected"
              type="button"
              role="tab"
              aria-controls="rejected"
              aria-selected={activeTab === 'rejected'}
              onClick={() => setActiveTab('rejected')}
            >
              On Hold Items
            </button>
          </li>
        </ul>

        {/* Tab content */}
        <div className="tab-content mt-3" id="itemTabsContent">
          <div
            className="tab-pane fade show active"
            id="all"
            role="tabpanel"
            aria-labelledby="all-tab"
          >
            {renderTable({ ...tableInstanceAll, typeFilter, setTypeFilter })}
          </div>
          <div
            className="tab-pane fade"
            id="finalized"
            role="tabpanel"
            aria-labelledby="finalized-tab"
          >
            {renderTable({ ...tableInstance2, typeFilter, setTypeFilter })}
          </div>
          <div
            className="tab-pane fade"
            id="draft"
            role="tabpanel"
            aria-labelledby="draft-tab"
          >
            {renderTable({ ...tableInstance1, typeFilter, setTypeFilter })}
          </div>
          <div
            className="tab-pane fade"
            id="rejected"
            role="tabpanel"
            aria-labelledby="rejected-tab"
          >
            {renderTable({ ...tableInstance3, typeFilter, setTypeFilter })}
          </div>
        </div>
      </div>
      </>)}

    </div>
  );
};

export default ItemMasterList;
